import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "AttachmentModelStore"*/ './lazyIndex'),
    { name: 'AttachmentModelStore' }
);

// Delay loaded actions
export const lazyAddAndInitializeAttachments: LazyAction<
    typeof lazyIndex.addAndInitializeAttachmentsMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addAndInitializeAttachmentsMutator);

export const lazyRefreshDownloadUrl: LazyAction<
    typeof lazyIndex.refreshDownloadUrl,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.refreshDownloadUrl);

export const lazyRefreshThumbnailImageUrl: LazyAction<
    typeof lazyIndex.refreshThumbnailImageUrl,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.refreshThumbnailImageUrl);

export const lazyRefreshPreviewImageUrl: LazyAction<
    typeof lazyIndex.refreshPreviewImageUrl,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.refreshPreviewImageUrl);

// Delay loaded imports
export const lazyGetAttachment: LazyAction<typeof lazyIndex.getAttachment, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.getAttachment);

export const lazyCheckPendingAttachmentOperation: LazyImport<
    typeof lazyIndex.checkPendingAttachmentOperation,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.checkPendingAttachmentOperation);

export const lazyShouldShowImageView: LazyImport<
    typeof lazyIndex.shouldShowImageView,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.shouldShowImageView);

export const lazyTryOpenLinkAttachment: LazyImport<
    typeof lazyIndex.tryOpenLinkAttachment,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.tryOpenLinkAttachment);
export const lazyGetAttachmentByContentId: LazyAction<
    typeof lazyIndex.getAttachmentByContentId,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAttachmentByContentId);

// SatchelV3 actions:
export {
    setAttachmentContentId,
    setAttachmentIsInline,
} from './actions/satchelV3Actions/publicActions';

export { default as AttachmentClass } from './store/schema/AttachmentClass';
export { default as attachmentStore } from './store/store';

export type {
    default as AttachmentInitializationParameters,
    AttachmentModelPropertyValues,
} from './store/schema/AttachmentInitializationParameters';
export { default as isSmimeAttachmentType, isSmimeAttachment } from './utils/isSmimeAttachmentType';
export type { default as SmimeAttachmentType } from './store/schema/SmimeAttachmentType';

export type {
    default as AttachmentModel,
    ReferenceAttachmentModel,
} from './store/schema/AttachmentModel';
export type { default as AttachmentInfo } from './store/schema/AttachmentInfo';
export type { default as UrlInfo } from './store/schema/UrlInfo';
